<template>
    <transition :name="transitionName">
        <div class="progress-bar" v-show="show" @transitionend="$emit('transitioned')">
            <div class="indicator-wrap">
                <div class="indicator"></div>
            </div>
        </div>
    </transition>
</template>

<script>

    export default {
        name: 'ProgressBar',

        props: {
            progress: {
                type: Number,
                default: 0
            },

            transitionName: {
                type: String,
                default: 'scale'
            }
        },

        data: () => (
            {
                show: true,
                indicator: 0
            }
        ),

        mounted() {
            this.indicator = this.$el.querySelector('.indicator');
        },

        watch: {
            progress() {
                let progress = Math.min(this.progress, 100);
                this.indicator.style.cssText = `transform: translate3d(${progress}%, 0, 0)`;

                if (progress == 100) {
                    var self = this;
                    setTimeout(function() {
                        self.$emit('finished', true);
                    }, 500);
                }
            }
        }
    }

</script>
